import { render, staticRenderFns } from "./UnitField.vue?vue&type=template&id=38763a9c&"
import script from "./UnitField.vue?vue&type=script&lang=js&"
export * from "./UnitField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports